import { connect } from 'react-redux'
import App from '../components/App/App'
import { IStore } from '../model/IStore'

const mapStateToProps = (state: IStore) => Object.assign({}, state.config) // Converts class to plain object

export default connect(mapStateToProps)(App)
